import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import {
  IComposedReportFilters,
  ScopeSelectKeys,
} from 'legacy/lut/components/widgets/public/partner360/composedReport'
import {
  mapFieldToTranslation,
  mapScopeKeyToLabel,
} from 'legacy/lut/components/widgets/public/partner360/composedReport/configs'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'
import { IComposedFilterForSave } from 'legacy/lut/features/partner360/composedReport'

import { Translation } from 'cng-common/features/translations/components/translation'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'

import { Circle } from './circle/Circle'
import { getStringWithTranslatedKeys } from './helpers/getStringWithTranslatedKeys'

import styles from './FiltersView.module.scss'

interface IProps {
  item: IComposedReportFilters
}

export const FiltersView = ({ item: { Filters } }: IProps) => {
  const t = useSafetyTranslation()
  const parsed = parseJson<IComposedFilterForSave>(Filters)

  if (!parsed) {
    return <></>
  }

  const notEmptyFields = Object.keys(parsed).filter((key) => {
    if (!parsed[key]) {
      return false
    }

    if (key === 'Acknowledged') {
      //we decided to temporarily hide this value
      return false
    }

    if (Array.isArray(parsed[key])) {
      return parsed[key].length > 0
    }

    if (key === 'Scope') {
      return Boolean(parsed[key].value)
    }

    return true
  })

  const getVisibleKeys = (notEmptyFields: string[]) => {
    const key = 'Scope'
    if (parsed[key].value === ScopeSelectKeys.Manual) {
      return notEmptyFields.filter((key) => key === 'Scope' || key === 'Products')
    }

    return notEmptyFields
  }

  const visibleKeys = getVisibleKeys(notEmptyFields)

  return (
    <div className={styles.root}>
      {visibleKeys.map((key) => {
        return (
          <div key={key} className={styles.row}>
            <Circle />

            <RenderWhen condition={key === 'Scope'}>
              <RenderWhen condition={parsed[key]?.value === ScopeSelectKeys.Manual}>
                <div className={styles.label}>
                  <Translation span text={TRANSLATION_KEYS.openFilterScopeCount} /> :&nbsp;
                </div>

                <span>{parsed[key].partnersInScope?.length || '-'}</span>
              </RenderWhen>

              <RenderWhen condition={parsed[key]?.value !== ScopeSelectKeys.Manual}>
                <div className={styles.label}>
                  <Translation span text={mapFieldToTranslation[key]} />: &nbsp;
                </div>
                <span>{mapScopeKeyToLabel[parsed[key]?.value]}</span>
              </RenderWhen>
            </RenderWhen>

            <RenderWhen condition={key !== 'Scope'}>
              <div className={styles.label}>
                <Translation span text={mapFieldToTranslation[key]} /> :&nbsp;
              </div>
              <span>{getStringWithTranslatedKeys({ data: parsed, key, t })}</span>
            </RenderWhen>
          </div>
        )
      })}
    </div>
  )
}
